import { useCmsPageByCode } from "@/features/shop/cms/hooks/useCmsPageByCode";
import { transformCmsBlocksToAutoScrollCards } from "@/features/shop/cms/utils/cmsBlockTransformers";
import { extractZoneByCode } from "@/features/shop/cms/utils/cmsZoneExtractor";
import { AutoScrollSlider } from "@/features/shop/components/AutoScrollSlider/AutoScrollSlider";

export type CmsAutoScrollSliderProps = {
  pageCode: string
  zoneCode: string
  scrollSpeed?: number
  offsetX?: number
  className?: string
};

export const CmsAutoScrollSlider = ({
  pageCode,
  zoneCode,
  scrollSpeed,
  offsetX = 0,
  className = "",
}: CmsAutoScrollSliderProps) => {
  const { data: cmsPageDetail, isLoading, isError } = useCmsPageByCode({
    code: pageCode,
    enabled: !!pageCode,
  });

  if (isLoading || isError || !cmsPageDetail) {
    return null;
  }

  const zone = extractZoneByCode(cmsPageDetail.zones, zoneCode);

  if (!zone || zone.blocks.length === 0) {
    return null;
  }

  const cards = transformCmsBlocksToAutoScrollCards(zone.blocks);

  return (
    <div className={className}>
      <AutoScrollSlider
        cards={cards}
        scrollSpeed={scrollSpeed}
        offsetX={offsetX}
      />
    </div>
  );
};
